import { Header } from "../../../../src/components/common/header";
import { GRCookiePolicy } from "../../../../src/components/cookie-policy/gr/index";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  Header,
  GRCookiePolicy,
  Footer,
  React
};